import { render, staticRenderFns } from "./LiveValue.vue?vue&type=template&id=3e544c5b"
import script from "./LiveValue.vue?vue&type=script&lang=js"
export * from "./LiveValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports